import { render, staticRenderFns } from "./WebSite.vue?vue&type=template&id=079b3578&"
import script from "./WebSite.vue?vue&type=script&lang=js&"
export * from "./WebSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079b3578')) {
      api.createRecord('079b3578', component.options)
    } else {
      api.reload('079b3578', component.options)
    }
    module.hot.accept("./WebSite.vue?vue&type=template&id=079b3578&", function () {
      api.rerender('079b3578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/WebSite/WebSite.vue"
export default component.exports